/* @ngInject */
const commandeRequest = (
  $q,
  commandeResource,
  valueHandler,
  labels,
  errorHandler,
  commandeFormat
) => {
  const self = {}

  self.getBySearch = async (data) => {
    return $q((resolve, reject) => {
      const functionName = '$commande.getBySearch'
      commandeResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            commandes: res.data,
            message: labels.commande.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.commande.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch()
  }

  self.getById = async (_id) => {
    return $q(async (resolve, reject) => {
      try {
        const response = await self.getBySearch({ id: _id, })
        const commandes = response.commandes
        if (commandes.length === 1) {
          resolve(commandes[0])
        } else {
          reject(labels.commande.log.search.noResult)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.save = (_commande, _wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$commande.save'

      const data = {
        commande: commandeFormat.server(_commande),
        wagonIds: _wagonIds,
      }

      commandeResource.save({}, data, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.commande.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.commande.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, data)
            reject(labels.commande.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_commande, _wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$commande.update'
      const data = {
        commande: commandeFormat.server(_commande),
        wagonIds: _wagonIds,
      }

      commandeResource.update({ action: _commande.id }, data, (res) => {
        if (res && res.success) {
          const response = {
            commande: res.data,
            message: labels.commande.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.commande.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$commande.delete'
      commandeResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.commande.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 23000) {
            reject(labels.commande.log.delete.wagonOnRailway)
          } else {
            errorHandler.message(res, functionName, _id)
            reject(labels.commande.log.delete.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default commandeRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/request.service.js